import script from "./AdminRoles.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminRoles.vue?vue&type=script&setup=true&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./AdminRoles.vue?vue&type=style&index=1&id=7be493ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be493ab"]])

export default __exports__